import { useState } from 'react';

export const useDelegate = (delegate: () => Promise<void>) => {

    const [isRunning, setRunning] = useState(false);

    const invoke = async () => {
        try{
            setRunning(true);
            await delegate();
        } finally {
            setRunning(false);
        }
    };

    const response: [() => Promise<void>, boolean] = [invoke, isRunning];

    return response;
};
